module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/icono_estadisticas.6d9878a5.svg";